export default __webpack_public_path__ + "static/eight-65e85387b50c570b364ddfbad8feaefc.png";